import { render, staticRenderFns } from "./QualificationsAdminTable.vue?vue&type=template&id=139eb0a2"
import script from "./QualificationsAdminTable.vue?vue&type=script&lang=js"
export * from "./QualificationsAdminTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports